<template>
  <div class="products-index-view">
    <h1>{{$t('titles.index')}}</h1>

    <link-button
      :to="{ name: 'new-standard-product' }"
      icon="plus"
      type="primary"
    >{{$t('actions.newStandard')}}</link-button>

    <link-button
      :to="{ name: 'new-bundle-product' }"
      icon="plus"
    >{{$t('actions.newBundle')}}</link-button>

    <search-input class="uk-align-right" ref="search" v-model="searchQuery" />

    <Collapsible class="uk-margin-medium-top" buttonName="Filter">
      <ProductsFilter @filter="onFilterChange"/> 
    </Collapsible>
    <data-grid
      :columns="gridColumns"
      :is-loading="isLoading"
      :page-info="products.pagination"
      :rows="products.entries"
      :sort-info="products.sort"
      :sortable="['name', 'articleNumber', 'updatedAt']"
      @sort="sortBy"
      class="uk-margin-small"
      v-if="gridLoaded"
    >
      <span slot="empty">{{$t('hints.empty')}}</span>
      <th class="products-index-view__thumbnail-cell" slot="beforeHead"></th>
      <template scope="props" slot="row">
        <td class="products-index-view__thumbnail-cell">
          <router-link
            :to="{ name: 'product', params: { id: props.row.id } }"
            v-if="props.row.teaserImage && props.row.teaserImage.thumbImageUrl"
          >
            <thumbnail :attachment="props.row.teaserImage" />
          </router-link>
          <text-placeholder v-else />
        </td>
        <td>
          <router-link
            :to="{ name: 'product', params: { id: props.row.id } }"
          >{{props.row.name}}</router-link>
          <div class="uk-text-muted">
            <product-type :bundle="props.row.bundle" />
          </div>
        </td>
        <td>
          <article-number :value="props.row.articleNumber" />
        </td>
        <td>
          <timeago :auto-update="60" :since="props.row.updatedAt" />
        </td>
        <td>
          <data-grid-actions
            :edit-route="{ name: 'edit-product', params: { id: props.row.id } }"
            @remove="deleteRecordWhenConfirmed(props.row)"
          >
            <li>
              <router-link
                :to="{ name: 'product-revisions', params: { id: props.row.id } }"
              >
                <icon name="future" />
              </router-link>
            </li>
          </data-grid-actions>
        </td>
      </template>
    </data-grid>

    <div
      class="loader-container uk-container uk-margin-medium-top uk-text-center"
      v-else
    >
      <loader />
    </div>
  </div>
</template>

<script>
import ArticleNumber from '@/components/ArticleNumber';
import deleteProductMutation from '@/api/mutations/delete-product.graphql';
import IndexView from '@/mixins/IndexView';
import productsQuery from '@/api/queries/products.graphql';
import ProductType from '@/components/ProductType';
import TextPlaceholder from '@/components/TextPlaceholder';
import Thumbnail from '@/components/Thumbnail';
import Yes from '@/components/Yes';
import Collapsible from '@/components/Common/Collapsible';
import ProductsFilter from '@/views/Products/IndexView/ProductsFilter';

export default {
  name: 'product-index-view',
  mixins: [
    IndexView('products', {
      gridFields: ['name', 'articleNumber', 'updatedAt'],
      listQuery: productsQuery,
      deleteMutation: deleteProductMutation,
      nameField: 'name',
    }),
  ],
  components: {
    ArticleNumber,
    ProductType,
    TextPlaceholder,
    Thumbnail,
    Yes,
    Collapsible,
    ProductsFilter,
  },
  data() {
    return {
      productFilter: {},
    };
  },
  computed: {
    additionalQueryVariables() {
      return {
        filter: this.productFilter,
      };
    },
  },
  methods: {
    onFilterChange(newFilter) {
      this.productFilter = newFilter;
      this.refetchList();
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          newStandard: 'Produkt erstellen',
          newBundle: 'Bundle erstellen',
        },
        hints: {
          empty: 'Keine Produkte gefunden.',
        },
        confirmations: {
          delete: `Produkt <strong>{name}</strong> wirklich löschen?
                   Alle zugehörigen Produkte, Bilder und Angebote werden
                   ebenfalls gelöscht.`,
        },
        titles: {
          index: 'Produkte',
        },
        toasts: {
          deleted: 'Produkt gelöscht: {name}',
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.products-index-view__thumbnail-cell {
  width: 44px;
}
</style>



// WEBPACK FOOTER //
// IndexView.vue?961e65e6